export const convertGrantNameToSingular = (name: string): string =>
  name.replace('BORSE', 'BORSA');
